import ProductPlusCover from './product-plus-cover';

export default ProductPlusCover;
